import { IMG, MENU } from "../data/content";
import { Eyebrow, Reveal } from "./Reveal";

export default function MenuHighlights() {
  return (
    <section id="menu" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="menu-section">
      <Reveal>
        <Eyebrow>The greatest hits</Eyebrow>
        <h2 className="mt-4 max-w-2xl font-serif text-2xl tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Ten reasons your group chat <em className="italic text-neon">is already planning a visit.</em>
        </h2>
        <p className="mt-4 max-w-xl text-base text-mist">
          No prices here — that's what the walk-in is for. Full menu on the table, and on Zomato.
        </p>
      </Reveal>

      <div className="mt-14 gap-12 lg:grid lg:grid-cols-[1fr_360px]">
        <ol className="divide-y divide-cream/8 border-y border-cream/8">
          {MENU.map((item, i) => (
            <Reveal key={item.name} delay={Math.min(i * 0.05, 0.3)} y={16}>
              <li
                data-testid={`menu-item-card-${i}`}
                className="group flex items-baseline gap-5 py-6 transition-colors duration-300 hover:bg-moss/40 sm:gap-8 sm:px-4"
              >
                <span className="font-mono text-xs text-mist transition-colors duration-300 group-hover:text-neon">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="flex-1">
                  <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                    <h3 className="font-serif text-xl text-cream transition-colors duration-300 group-hover:text-neon sm:text-2xl">
                      {item.name}
                    </h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-mist">{item.category}</span>
                  </div>
                  <p className="mt-1.5 max-w-lg text-sm leading-relaxed text-sage">{item.desc}</p>
                </div>
                <span className="hidden shrink-0 rounded-full border border-neon/25 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] text-neon/90 sm:block">
                  {item.badge}
                </span>
              </li>
            </Reveal>
          ))}
        </ol>

        <Reveal delay={0.15} className="mt-10 lg:mt-0">
          <div className="lg:sticky lg:top-24">
            <figure className="group relative overflow-hidden rounded-2xl border border-cream/5" data-testid="menu-feature-image">
              <img
                src={IMG.cheesePull}
                alt="Cheese pull on a pesto paneer pizza at Brewing Bistro"
                loading="lazy"
                className="aspect-[9/13] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.05]"
              />
            </figure>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
